import { api } from '../api';

export const updateAssetsSession: () => Promise<void> = (): Promise<void> => api.post(
  '/assets/session', undefined, { withCredentials: true, baseURL: api.defaults.baseURL?.replace('/api', '') }
);
